import { Routes } from "@angular/router";
import { ROUTES } from "@app/shared/constants/routes.constants";
import { TwoFactorAuthenticationGuard } from "./shared/components/two-factor-authentication/two-factor-authentication.guard";

export const routes: Routes = [
  {
    path: ROUTES.ERROR,
    loadChildren: () => import("@app/app-modules/error/error.routes").then((m) => m.routes)
  },
  {
    path: ROUTES.LOGIN,
    loadChildren: () => import("@app/app-modules/login/login-routes").then((m) => m.routes),
    data: { preload: true }
  },
  {
    path: ROUTES.HOME,
    loadChildren: () => import("@app/app-modules/shell/shell-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.CHANGE_PASSWORD,
    loadChildren: () => import("@app/shared/components/change-password/change-password-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.TWO_FACTOR_VERIFY,
    canActivate: [TwoFactorAuthenticationGuard],
    loadComponent: () =>
      import(
        "@app/shared/components/two-factor-authentication/two-factor-authentication-form-verify/two-factor-authentication-form-verify.component"
      ).then((m) => m.TwoFactorAuthenticationFormVerifyComponent)
  },
  {
    path: ROUTES.TWO_FACTOR_ENABLE,
    canActivate: [TwoFactorAuthenticationGuard],
    loadComponent: () =>
      import(
        "@app/shared/components/two-factor-authentication/two-factor-authentication-enable/two-factor-authentication-enable.component"
      ).then((m) => m.TwoFactorAuthenticationEnableComponent)
  },
  {
    path: "**",
    loadComponent: () =>
      import("@app/app-modules/error/error-404/error-404.component").then((m) => m.Error404Component),
    pathMatch: "full"
  }
];
